module.exports = __webpack_public_path__ + "img/logistica-thumb.bf3c28e6.jpg";